import React, { useState, useEffect } from 'react';
import { Route } from 'react-router';
import axios from 'axios';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import IndexLife from "./SmcLife/IndexLife";
import LifeMoreDetail from "./SmcLife/LifeMoreDetail";
import LifeQuoteDetail from "./SmcLife/LifeQuoteDetail";
import LifeQuoteEnquiry from "./SmcLife/LifeQuoteEnquiry";
import LifeQuotationCard from "./SmcLife/LifeQuotationCard";
import SmcLifeProposal from "./SmcLife/SmcLifeProposal";
import SmcLifeQuote from "./SmcLife/SmcLifeQuote";
import EditDetailCard from "./SmcLife/EditDetailCard";
import { NavMenu } from './components/NavMenu';
import WhatsAppBot from './components/whatsappbot/WhatsAppBot';
import "./components/css/Header.css"

class ApiSingleton {
    static instance;
    static Masters = {
        OccupationList: [],
        EducationList: []
    };

    static getInstance() {
        if (!ApiSingleton.instance) {
            ApiSingleton.instance = new ApiSingleton();
        }
        return ApiSingleton.instance;
    }

    async fetchData() {
        if (ApiSingleton.Masters.OccupationList.length === 0 || ApiSingleton.Masters.EducationList.length === 0) {
            try {
                //const masterKey = ["QUALIFICATION"];
               // const data = await Promise.all(masterKey.map(r => axios.post(`central/centralcall/CallReqWithHeader`, { URL: "GetMaster", PostString: JSON.stringify({ InsurerId: 0, MasterType: r, Somid :0}) })));
                const masterKey = ["OCCUPATION", "QUALIFICATION"];
                const data = await Promise.all(masterKey.map(r => {
                    const payload = { URL: r === 'OCCUPATION' ? 'GetCommonOccupation' : 'GetMaster' };
                    if (r !== 'OCCUPATION') {
                        payload.PostString = JSON.stringify({ InsurerId: 0, MasterType: r, Somid: 0 });
                    }
                    return axios.post(`central/centralcall/CallReqWithHeader`, payload);
                }));
                for (let i = 0; i < masterKey.length; i++) {

                    switch (masterKey[i]) {
                        case "OCCUPATION":
                           ApiSingleton.Masters.OccupationList = data[i].data;
                           break;
                        case "QUALIFICATION":
                            ApiSingleton.Masters.EducationList = data[i].data.Data;
                            break;
                        default:
                            break;
                    }

                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        return ApiSingleton.Masters;
    }
}

export { ApiSingleton };

const App = () => {
    const [IsHideDash, setDeshBoard] = useState(true);
    const [UserData, setUserData] = useState("");
    const [cookies, setCookies] = useState();
    const [showWhatsAppBot, setWhatsAppBot] = useState(false);

    useEffect(() => {
        const allCookies = getCookies();
        if (allCookies.priviledge) {
            try {
                const obj = JSON.parse(atob(allCookies.priviledge));
                setCookies(obj);
            } catch (error) {
                console.error('Error decoding privilege cookie', error);
            }
        }

        const token = window.localStorage.getItem("token");
        if (token) {
            const parseToken = token.charAt(0) === "{";
            const data = {
                Token: parseToken ? JSON.parse(token).token : token,
            };

            const md = {
                URL: "GetUserInfo",
                PostString: JSON.stringify(data),
            };

            axios.post("/central/centralcall/CallReqWithHeader", md)
                .then((res) => {
                    if (res.data.userID !== "Session is abort") {
                        //dispatch(setUserData(res?.data));
                        setUserData(res?.data);
                        setDeshBoard(!(res.data.roleID === 29 || res.data.roleID === 32));

                        if (res.data.userID > 0) {
                            window.sessionStorage.setItem("UserID", res.data.userID);
                        }
                    } else {
                        setWhatsAppBot(true);
                        window.localStorage.removeItem("token");
                    }
                });
        } else {
            setWhatsAppBot(true);
        }

        //console.log(UserData, "User Data");
    }, []);

   /* useEffect(() => {
        console.log(cookies, "cookies Data 2 (after state update)");
    }, [cookies]); */
    const getCookies = () => {
        var cookies = document.cookie.split(';');
        var cookieMap = {};
        cookies.forEach(function (cookie) {
            var parts = cookie.split('=');
            var name = parts[0].trim();
            var value = decodeURIComponent(parts[1]);
            cookieMap[name] = value;
        });
        return cookieMap;
    };
    //useEffect(() => {
    //    if (cookies) {
    //        const hasBlockPos = cookies?.priviledgeList.some(
    //            (item) => item.PrivilegeName.toLowerCase() === "become a pos"
    //        );
    //        //console.log(hasBlockPos, "Affiliate"); // Output will be true or false
    //        setBlockPos(hasBlockPos);
    //    } else {
    //        console.log("priviledgeList is not an array or cookies is undefined");
    //    }
    //}, [cookies]);

    useEffect(() => {
        if (UserData.userID === 188452) {
            document.documentElement.style.setProperty('--Prim-Color', "#5430bb");
            document.documentElement.style.setProperty('--LightBG', "#f1f7ff");
            document.documentElement.style.setProperty('--DarkBG-BTN', "#3c17a5");
            document.documentElement.style.setProperty('--BrightnessDark', "brightness(0)");
            document.documentElement.style.setProperty('--AllImages', "grayscale(1)");
            document.documentElement.style.setProperty('--BTN-Radius', "10px");
            document.documentElement.style.setProperty('--Radio-Color', "blue");
            document.documentElement.style.setProperty('--Font-Family', "'Roboto', sans-serif");
            document.documentElement.style.setProperty('--AllImagesColor', "grayscale(0)");
        } else if (UserData.userID === 29502) {
            document.documentElement.style.setProperty('--Prim-Color', "#3F4599");
            document.documentElement.style.setProperty('--PrimeTextColor', "#161719");
            document.documentElement.style.setProperty('--SecondryTextColor', "#5F6570");
            document.documentElement.style.setProperty('--LightBG', "#eef1fabd");
            document.documentElement.style.setProperty('--DarkBG-BTN', "#30368e");
            document.documentElement.style.setProperty('--BrightnessDark', "brightness(0)");
            document.documentElement.style.setProperty('--BTN-Radius', "5px");
            document.documentElement.style.setProperty('--Radio-Color', "blue");
            document.documentElement.style.setProperty('--Font-Family', "'Poppins', sans-serif");
            document.documentElement.style.setProperty('--AllImagesColor', "grayscale(0)");
            document.documentElement.style.setProperty('--AllImagesColor1', "grayscale(1)");
            document.documentElement.style.setProperty('--ComnFontSize', "11px");
            document.documentElement.style.setProperty('--MiddFontSize', "14px");
        }
    }, [UserData]);

    return (
        <React.Fragment>
            <div className={IsHideDash === false ? "SMCbody NewUIStyle OnlyAlliance" : "SMCbody NewUIStyle"}>
                <NavMenu CoockieData={cookies} Udata={UserData} />
                {showWhatsAppBot && <WhatsAppBot />}
                <Route exact path="/critical-illness" component={() => <IndexLife From={"critical-illness"} />} />
                <Route exact path="/" component={() => <IndexLife From={"Gen"} />} />
                <Route exact path="/women-term" component={() => <IndexLife From={"women-term"} />} />
                <Route exact path="/housewife-term" component={() => <IndexLife From={"housewife-term"} />} />
                <Route exact path="/2Cr-term" component={() => <IndexLife From={"2cr-term"} />} />
                <Route exact path="/LifeMoreDetail" component={LifeMoreDetail} />
                <Route exact path="/SmcLifeQuote" component={SmcLifeQuote} />
                <Route exact path="/LifeQuoteDetail" component={LifeQuoteDetail} />
                <Route exact path="/LifeQuoteEnquiry" component={LifeQuoteEnquiry} />
                <Route exact path="/LifeQuotationCard" component={LifeQuotationCard} />
                <Route exact path="/SmcLifeProposal" component={SmcLifeProposal} />
                <Route exact path="/EditDetailCard" component={EditDetailCard} />
            </div>
        </React.Fragment>
    );
}

export default App;
